import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-e4a0e6c0"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "fondecran",
    style: {
      "background": "#f3f3f3"
    }
  }, null, -1);
});

var _hoisted_2 = ["src"];
var _hoisted_3 = {
  class: "d-lg-block d-none"
};
var _hoisted_4 = {
  class: "d-lg-block d-none"
};
var _hoisted_5 = {
  class: "d-block d-lg-none bg-white"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_NavbarVue = _resolveComponent("NavbarVue");

  var _component_ImageCompareVue = _resolveComponent("ImageCompareVue");

  var _component_MenuLeftVue = _resolveComponent("MenuLeftVue");

  var _component_MenuBottom = _resolveComponent("MenuBottom");

  var _component_MenuMobile = _resolveComponent("MenuMobile");

  var _component_ModalLoader = _resolveComponent("ModalLoader");

  var _directive_loading = _resolveDirective("loading");

  return _openBlock(), _createElementBlock("div", null, [_withDirectives(_createVNode(_component_NavbarVue, {
    "element-loading-text": "Chargement en cours...",
    "element-loading-spinner": _ctx.svg,
    "element-loading-svg-view-box": "-10, -10, 50, 50",
    "element-loading-background": "rgba(0, 0, 0, 0.8)",
    id: "header-box",
    style: _normalizeStyle("z-index: ".concat(_ctx.loading ? 9999 : 1))
  }, null, 8, ["element-loading-spinner", "style"]), [[_directive_loading, _ctx.loading]]), _hoisted_1, _withDirectives(_createElementVNode("div", null, [_createVNode(_component_ImageCompareVue, {
    class: _normalizeClass({
      'd-none': !_ctx.isCompare.active
    }),
    loading: _ctx.loading,
    "onUpdate:loading": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.loading = $event;
    }),
    secondImage: _ctx.modifiedImage.src,
    firstImage: _ctx.compareFirstImage
  }, null, 8, ["class", "loading", "secondImage", "firstImage"])], 512), [[_vShow, _ctx.isCompare.active]]), _createElementVNode("div", {
    class: _normalizeClass({
      'd-none': _ctx.isCompare.active
    }),
    id: "printMe"
  }, [_createElementVNode("img", {
    style: {
      "width": "100%"
    },
    src: _ctx.modifiedImage.src,
    id: "img"
  }, null, 8, _hoisted_2)], 2), _createElementVNode("div", _hoisted_3, [_createVNode(_component_MenuLeftVue, {
    "is-compare": _ctx.isCompare,
    "handle-compare": _ctx.handleCompare,
    "open-modal-floor": function openModalFloor() {
      return _ctx.setModal('SelectFloor');
    },
    "open-modal-wall": function openModalWall() {
      return _ctx.setModal('SelectWall');
    },
    "open-modal-espace": function openModalEspace() {
      return _ctx.setModal('SelectEspace');
    }
  }, null, 8, ["is-compare", "handle-compare", "open-modal-floor", "open-modal-wall", "open-modal-espace"])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_MenuBottom, {
    "handle-zoom": function handleZoom() {
      return _ctx.setModal('ZoomModal');
    },
    "print-image": _ctx.printImg
  }, null, 8, ["handle-zoom", "print-image"])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_MenuMobile, {
    "handle-compare": _ctx.handleCompare,
    "open-modal-floor": function openModalFloor() {
      return _ctx.setModal('SelectFloor');
    },
    "open-modal-wall": function openModalWall() {
      return _ctx.setModal('SelectWall');
    },
    "open-modal-espace": function openModalEspace() {
      return _ctx.setModal('SelectEspace');
    },
    "handle-zoom": function handleZoom() {
      return _ctx.setModal('ZoomModal');
    },
    "print-image": _ctx.printImg
  }, null, 8, ["handle-compare", "open-modal-floor", "open-modal-wall", "open-modal-espace", "handle-zoom", "print-image"])]), _createVNode(_component_ModalLoader)]);
}